import { FolderAlertOutlineIcon } from './FolderAlertOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 9CF67925-5A21-47F8-8EF5-F567D902C1D2
 * name folder-alert-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-alert-outline.svg
 * tags
 * - Files / Folders 
 * - Alert / Error 
 */
export const FolderWarningOutlineIcon = FolderAlertOutlineIcon;
export default FolderWarningOutlineIcon